import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useRelatedSearchesOnSrpsExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.RelatedSearchesOnSrps,
        AmplitudeVariants.RelatedSearchesOnSrps.Treatment
    );
